import { Box, styled } from '@mui/material';

export const MenuListWrap = styled(Box)(({ theme }) => ({
	padding: theme.spacing(3, 2, 4),
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2),
}));

export const MenuGrid = styled(Box)(() => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
	gap: '8px',
}));
